(() => {
  const IMAGE_HOSTS = ['review-images.judgeme.com', 'review-images.judge.me'];
  let reviewLightbox = null;
  let reviewLightboxItems = [];
  let reviewLightboxIndex = 0;
  let reviewLightboxScrollY = 0;

  const reviewImageSource = (img) => {
    const rawSrc = img?.currentSrc || img?.src || '';
    if (!rawSrc) return '';
    try {
      const url = new URL(rawSrc, window.location.href);
      if (IMAGE_HOSTS.includes(url.hostname)) url.search = '';
      return url.toString();
    } catch (_) {
      return rawSrc;
    }
  };

  const reviewDetailsForSource = (source) => {
    const normalizedSource = source.split('?')[0];
    const widget = document.querySelector('.jdgm-review-widget[data-product-id]');
    const productId = widget?.dataset.productId;
    const photoGallery = window.jdgm?.data?.reviewWidget?.[productId]?.photo_gallery || [];
    const galleryReview = photoGallery.find((review) => (review.pictures_urls || []).some((picture) => {
      const pictureSource = picture.original || picture.huge || picture.compact || picture.small || '';
      return pictureSource.split('?')[0] === normalizedSource;
    }));
    if (galleryReview) {
      const bodyContainer = document.createElement('div');
      bodyContainer.innerHTML = galleryReview.body_html || '';
      const rating = Math.max(0, Math.min(5, Math.round(Number.parseFloat(galleryReview.rating) || 0)));
      return {
        stars: '★'.repeat(rating) + '☆'.repeat(5 - rating),
        title: galleryReview.title || '',
        body: bodyContainer.textContent?.trim() || '',
      };
    }

    const reviews = Array.from(document.querySelectorAll('.jdgm-review-widget .jm-review-item'));
    const review = reviews.find((item) => Array.from(item.querySelectorAll('img')).some((img) => reviewImageSource(img).split('?')[0] === normalizedSource));
    if (!review) return { stars: '', title: '', body: '' };
    const title = review.querySelector('.jm-review-content__title')?.textContent?.trim() || '';
    const body = review.querySelector('.jm-review-content__body, .jdgm-review-content__body-content')?.textContent?.trim() || '';
    const ratingLabel = review.querySelector('.jm-star-rating')?.getAttribute('aria-label') || '';
    const numericRating = Number.parseFloat(ratingLabel.replace(/[^0-9.]/g, ''));
    const filledStars = Number.isFinite(numericRating) ? Math.max(0, Math.min(5, Math.round(numericRating))) : 5;
    return { stars: '★'.repeat(filledStars) + '☆'.repeat(5 - filledStars), title, body };
  };

  const ensureReviewLightbox = () => {
    if (reviewLightbox) return reviewLightbox;
    reviewLightbox = document.createElement('div');
    reviewLightbox.className = 'sakura-review-lightbox';
    reviewLightbox.setAttribute('aria-hidden', 'true');
    reviewLightbox.setAttribute('role', 'dialog');
    reviewLightbox.setAttribute('aria-label', 'Review photo gallery');
    reviewLightbox.innerHTML = '<div class="sakura-review-lightbox__panel"><div class="sakura-review-lightbox__stage"><img class="sakura-review-lightbox__image" alt="Customer review photo"><button class="sakura-review-lightbox__close" type="button" aria-label="Close">×</button><button class="sakura-review-lightbox__arrow sakura-review-lightbox__arrow--prev" type="button" aria-label="Previous photo">‹</button><button class="sakura-review-lightbox__arrow sakura-review-lightbox__arrow--next" type="button" aria-label="Next photo">›</button><div class="sakura-review-lightbox__count" aria-live="polite"></div></div><div class="sakura-review-lightbox__review"><div class="sakura-review-lightbox__stars"></div><h3 class="sakura-review-lightbox__title"></h3><p class="sakura-review-lightbox__body"></p></div></div>';
    document.body.appendChild(reviewLightbox);

    const image = reviewLightbox.querySelector('.sakura-review-lightbox__image');
    const count = reviewLightbox.querySelector('.sakura-review-lightbox__count');
    const reviewPanel = reviewLightbox.querySelector('.sakura-review-lightbox__review');
    const stars = reviewLightbox.querySelector('.sakura-review-lightbox__stars');
    const title = reviewLightbox.querySelector('.sakura-review-lightbox__title');
    const body = reviewLightbox.querySelector('.sakura-review-lightbox__body');
    const render = () => {
      if (!reviewLightboxItems.length) return;
      reviewLightboxIndex = (reviewLightboxIndex + reviewLightboxItems.length) % reviewLightboxItems.length;
      const current = reviewLightboxItems[reviewLightboxIndex];
      image.src = current.src;
      count.textContent = (reviewLightboxIndex + 1) + ' / ' + reviewLightboxItems.length;
      stars.textContent = current.review.stars;
      title.textContent = current.review.title;
      body.textContent = current.review.body;
      reviewPanel.hidden = !current.review.title && !current.review.body;
    };
    const move = (step) => {
      reviewLightboxIndex += step;
      render();
    };
    const close = () => {
      reviewLightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sakura-review-lightbox-open');
      document.body.classList.remove('sakura-review-lightbox-open');
      document.body.style.removeProperty('top');
      image.removeAttribute('src');
      window.scrollTo(0, reviewLightboxScrollY);
    };

    reviewLightbox.querySelector('.sakura-review-lightbox__close').addEventListener('click', close);
    reviewLightbox.querySelector('.sakura-review-lightbox__arrow--prev').addEventListener('click', () => move(-1));
    reviewLightbox.querySelector('.sakura-review-lightbox__arrow--next').addEventListener('click', () => move(1));
    reviewLightbox.addEventListener('click', (event) => {
      if (event.target === reviewLightbox) close();
    });
    document.addEventListener('keydown', (event) => {
      if (reviewLightbox.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });

    let touchStartX = null;
    reviewLightbox.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    reviewLightbox.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 45) return;
      move(delta > 0 ? -1 : 1);
    }, { passive: true });

    reviewLightbox._sakuraRender = render;
    return reviewLightbox;
  };

  const openReviewLightbox = (track, item) => {
    const items = Array.from(track.querySelectorAll('.jm-media-grid__item'));
    reviewLightboxItems = items.map((entry) => {
      const src = reviewImageSource(entry.querySelector('img'));
      return src ? { src, review: reviewDetailsForSource(src) } : null;
    }).filter(Boolean);
    const selectedSource = reviewImageSource(item.querySelector('img'));
    reviewLightboxIndex = Math.max(0, reviewLightboxItems.findIndex((entry) => entry.src === selectedSource));
    const lightbox = ensureReviewLightbox();
    lightbox.setAttribute('aria-hidden', 'false');
    reviewLightboxScrollY = window.scrollY;
    document.documentElement.classList.add('sakura-review-lightbox-open');
    document.body.classList.add('sakura-review-lightbox-open');
    document.body.style.setProperty('top', '-' + reviewLightboxScrollY + 'px');
    lightbox._sakuraRender();
  };

  const setupReviewPhotoClicks = () => {
    document.querySelectorAll('.jdgm-review-widget .jm-media-grid__container').forEach((track) => {
      if (track.dataset.sakuraReviewClicks === 'true') return;
      track.dataset.sakuraReviewClicks = 'true';
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerMoved = false;
      track.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerMoved = false;
      }, { passive: true });
      track.addEventListener('pointermove', (event) => {
        if (Math.abs(event.clientX - pointerStartX) > 10 || Math.abs(event.clientY - pointerStartY) > 10) pointerMoved = true;
      }, { passive: true });
      track.addEventListener('click', (event) => {
        const item = event.target.closest('.jm-media-grid__item');
        if (!item) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!pointerMoved) openReviewLightbox(track, item);
      }, true);
    });
  };

  const upgradeImage = (img) => {
    if (!(img instanceof HTMLImageElement)) return;
    const rawSrc = img.currentSrc || img.src;
    if (!rawSrc || !IMAGE_HOSTS.some((host) => rawSrc.includes(host))) return;

    try {
      const url = new URL(rawSrc, window.location.href);
      const inViewer = Boolean(img.closest('[class*="modal"], [class*="lightbox"], [role="dialog"]'));
      const inPhotoCarousel = Boolean(img.closest('.jm-media-preview'));
      if (inViewer || inPhotoCarousel) {
        if (inPhotoCarousel && !inViewer) {
          img.loading = 'lazy';
          img.fetchPriority = 'low';
          img.decoding = 'async';
        } else {
          img.loading = 'eager';
          img.fetchPriority = 'high';
        }
        url.search = '';
        const originalUrl = url.toString();
        if (img.src !== originalUrl) {
          img.removeAttribute('srcset');
          img.src = originalUrl;
        }
        img.dataset.sakuraReviewQuality = 'original';
        return;
      }

      const width = window.matchMedia('(max-width: 749px)').matches ? 600 : 800;
      const quality = 92;
      img.loading = 'lazy';
      img.fetchPriority = 'low';
      img.decoding = 'async';
      if (url.searchParams.get('width') === String(width) && url.searchParams.get('quality') === String(quality)) return;

      url.searchParams.set('width', String(width));
      url.searchParams.set('quality', String(quality));
      img.removeAttribute('srcset');
      img.src = url.toString();
    } catch (_) {
      // Keep Judge.me's original source if its URL format changes.
    }
  };

  const upgradeAll = (root = document) => {
    root.querySelectorAll?.('img[src*="review-images.judgeme.com"], img[srcset*="review-images.judgeme.com"], img[src*="review-images.judge.me"], img[srcset*="review-images.judge.me"]').forEach(upgradeImage);
  };

  const setupReviewImageLoading = () => {
    document.querySelectorAll('.jdgm-review-widget .jm-media-preview').forEach((preview) => {
      if (preview.dataset.sakuraReviewImageLoading === 'true') return;
      const track = preview.querySelector('.jm-media-grid__container');
      if (!track) return;
      preview.dataset.sakuraReviewImageLoading = 'true';

      const warmImage = (img, priority = 'low') => {
        if (!(img instanceof HTMLImageElement)) return;
        img.loading = 'lazy';
        img.fetchPriority = 'low';
        img.decoding = 'async';
      };

      const warmInitial = () => {
        const images = Array.from(track.querySelectorAll('.jm-media-grid__item img'));
        warmImage(images[0], 'low');
        warmImage(images[1], 'low');
      };

      const warmAdjacent = () => {
        const items = Array.from(track.querySelectorAll('.jm-media-grid__item'));
        if (!items.length) return;
        let currentIndex = 0;
        let nearestDistance = Infinity;
        items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - track.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            currentIndex = index;
          }
        });
        [currentIndex - 1, currentIndex, currentIndex + 1].forEach((index) => {
          warmImage(items[index]?.querySelector('img'));
        });
      };

      const proximityObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        warmInitial();
        observer.disconnect();
      }, { rootMargin: '200px 0px' });
      proximityObserver.observe(preview);

      track.addEventListener('pointerdown', warmAdjacent, { passive: true });
      let warmFrame = null;
      track.addEventListener('scroll', () => {
        if (warmFrame !== null) return;
        warmFrame = window.requestAnimationFrame(() => {
          warmFrame = null;
          warmAdjacent();
        });
      }, { passive: true });
    });
  };

  const updateRatingFills = () => {
    const productStarFills = Array.from(
      document.querySelectorAll('.product__info-container .sakura-precise-rating-stars .sakura-precise-rating-star'),
    ).map((star) => Number.parseFloat(star.style.getPropertyValue('--sakura-star-fill')));
    const productFill = productStarFills.length === 5 && productStarFills.every(Number.isFinite)
      ? productStarFills.reduce((total, value) => total + value, 0) / 5
      : null;

    document.querySelectorAll('.jdgm-review-widget .jm-average-rating-display').forEach((display) => {
      if (productFill !== null) {
        display.querySelector('.jm-cluster')?.style.setProperty('--sakura-rating-fill', productFill + '%');
        return;
      }

      const ratingText = display.querySelector('.jm-text:first-of-type')?.textContent || '';
      const rating = Number.parseFloat(ratingText.replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(rating)) return;
      const boundedRating = Math.max(0, Math.min(5, rating));
      const wholeStars = Math.floor(boundedRating);
      const actualFraction = Math.round((boundedRating - wholeStars) * 100);
      let visualFraction = actualFraction;

      // Keep this identical to the fractional-star logic used under the product title.
      if (actualFraction >= 90 && actualFraction < 100) visualFraction = 60;
      else if (actualFraction >= 80 && actualFraction < 90) visualFraction = 50;
      else if (actualFraction >= 70 && actualFraction < 80) visualFraction = 45;

      const fill = ((wholeStars * 100) + visualFraction) / 5;
      display.querySelector('.jm-cluster')?.style.setProperty('--sakura-rating-fill', fill + '%');
    });
  };

  const copyProductReviewCountToSummary = () => {
    const productCount = document.querySelector(
      '.product__info-container .rating-count span[aria-hidden="true"], .product.sakura-product-layout .rating-count span[aria-hidden="true"]',
    )?.textContent?.trim();
    if (!productCount) return;

    const normalizedCount = productCount.startsWith('(') && productCount.endsWith(')')
      ? productCount
      : '(' + productCount.replace(/[()]/g, '').trim() + ')';

    document.querySelectorAll('.jdgm-review-widget .jm-average-rating-display > .jm-cluster').forEach((cluster) => {
      let count = cluster.querySelector('.sakura-review-summary-count');
      if (!count) {
        count = document.createElement('span');
        count.className = 'sakura-review-summary-count';
        count.setAttribute('aria-label', normalizedCount.replace(/[()]/g, '') + ' reviews');
        cluster.appendChild(count);
      }
      if (count.textContent !== normalizedCount) count.textContent = normalizedCount;
    });
  };

  const enforceReviewSummaryLayout = () => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const targetWidth = mobile ? '286px' : '360px';
    document.querySelectorAll('.jdgm-review-widget .jm-review-widget-minimal-header__filter-container').forEach((filter) => {
      filter.style.setProperty('width', targetWidth, 'important');
      filter.style.setProperty('min-width', targetWidth, 'important');
      filter.style.setProperty('max-width', targetWidth, 'important');
      filter.style.setProperty('align-self', 'center', 'important');
      filter.style.setProperty('flex', '0 0 auto', 'important');
      filter.style.setProperty('margin-left', 'auto', 'important');
      filter.style.setProperty('margin-right', 'auto', 'important');
      filter.style.setProperty('transform', 'none', 'important');
      filter.querySelectorAll('.jm-review-widget-minimal-header__button-and-filters, .jm-action-buttons, .jm-action-buttons > .jm-stack, .jm-action-buttons__button').forEach((element) => {
        element.style.setProperty('width', '100%', 'important');
        element.style.setProperty('min-width', '100%', 'important');
        element.style.setProperty('max-width', '100%', 'important');
      });
      filter.querySelectorAll('.jm-review-widget-minimal-header__button-and-filters, .jm-action-buttons').forEach((element) => {
        element.style.setProperty('gap', '0', 'important');
        element.style.setProperty('margin-left', 'auto', 'important');
        element.style.setProperty('margin-right', 'auto', 'important');
      });
    });
  };

  const setupPhotoCarousels = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.jdgm-review-widget .jm-media-preview').forEach((preview) => {
      let track = preview.querySelector('.jm-media-grid__container');
      if (!track || preview.querySelector('.sakura-photo-review-nav')) return;

      // Rebuild Judge.me's DIV > BUTTON media grid using the exact semantic
      // structure used by the product gallery: SLIDER-COMPONENT > UL > LI.
      // This removes the button gesture layer that makes iOS dragging feel
      // different from the product gallery.
      if (!track.classList.contains('sakura-product-style-review-slider')) {
        const originalItems = Array.from(track.querySelectorAll('.jm-media-grid__item'));
        if (!originalItems.length) return;

        const sliderComponent = document.createElement('slider-component');
        sliderComponent.className = 'slider-mobile-gutter sakura-review-slider-component';

        const productStyleTrack = document.createElement('ul');
        productStyleTrack.className = 'jm-media-grid__container sakura-product-style-review-slider product__media-list contains-media grid list-unstyled slider slider--mobile';
        productStyleTrack.setAttribute('role', 'list');

        originalItems.forEach((originalItem, index) => {
          const slide = document.createElement('li');
          slide.className = 'jm-media-grid__item product__media-item grid__item slider__slide';
          slide.id = 'Slide-ReviewPhoto-' + index + '-' + Math.random().toString(36).slice(2, 8);
          while (originalItem.firstChild) slide.appendChild(originalItem.firstChild);
          productStyleTrack.appendChild(slide);
        });

        sliderComponent.appendChild(productStyleTrack);
        track.replaceWith(sliderComponent);
        track = productStyleTrack;
      }

      const nav = document.createElement('div');
      nav.className = 'sakura-photo-review-nav';
      nav.setAttribute('aria-label', 'Photo review navigation');
      nav.innerHTML = '<button type="button" data-step="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21L7 12l9-9"/></svg></button><button type="button" data-step="1" aria-label="Next photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3l9 9-9 9"/></svg></button>';

      const buttons = nav.querySelectorAll('button');
      const getCarouselState = () => {
        const items = Array.from(track.querySelectorAll('.jm-media-grid__item'));
        const positions = items.map((item) => item.offsetLeft);
        let currentIndex = 0;
        let smallestDistance = Infinity;
        positions.forEach((position, index) => {
          const distance = Math.abs(position - track.scrollLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentIndex = index;
          }
        });
        return { items, positions, currentIndex };
      };

      const goToIndex = (index) => {
        const state = getCarouselState();
        if (!state.items.length) return;
        const targetIndex = Math.max(0, Math.min(state.items.length - 1, index));
        track.scrollTo({ left: state.positions[targetIndex], behavior: 'smooth' });
      };

      const updateButtons = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        buttons[0].style.visibility = track.scrollLeft <= 2 ? 'hidden' : 'visible';
        buttons[1].style.visibility = track.scrollLeft >= max ? 'hidden' : 'visible';
      };

      nav.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-step]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        const state = getCarouselState();
        goToIndex(state.currentIndex + Number(button.dataset.step));
      });

      nav.addEventListener('pointerdown', (event) => {
        if (!event.target.closest('button[data-step]')) return;
        event.stopPropagation();
      });

      nav.addEventListener('touchstart', (event) => {
        if (!event.target.closest('button[data-step]')) return;
        event.stopPropagation();
      }, { passive: true });

      let scrollUpdateFrame = null;
      const scheduleButtonUpdate = () => {
        if (scrollUpdateFrame !== null) return;
        scrollUpdateFrame = window.requestAnimationFrame(() => {
          scrollUpdateFrame = null;
          updateButtons();
        });
      };

      track.addEventListener('scroll', scheduleButtonUpdate, { passive: true });
      preview.appendChild(nav);
      updateButtons();
    });
  };

  const balanceDesktopReviewGrid = () => {
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    document.querySelectorAll('.jdgm-review-widget .jdgm-review-list').forEach((list) => {
      const items = Array.from(list.children).filter((item) => item.classList.contains('jm-review-item'));
      items.forEach((item) => {
        item.classList.remove('sakura-centered-review-card');
        item.style.removeProperty('order');
      });
      if (!desktop || items.length < 2) return;

      const textReviews = items.filter((item) => !item.querySelector('.jm-media-thumbnail-list__thumbnail'));
      const photoReviews = items.filter((item) => item.querySelector('.jm-media-thumbnail-list__thumbnail'));
      const textRemainder = textReviews.length % 2 === 1 ? textReviews.pop() : null;
      const photoRemainder = photoReviews.length % 2 === 1 ? photoReviews.pop() : null;
      const remainders = [photoRemainder, textRemainder].filter(Boolean);
      const orderedItems = [...textReviews, ...photoReviews, ...remainders];
      let order = 0;

      orderedItems.forEach((item) => {
        item.style.setProperty('order', String(order));
        order += 1;
      });

      // Keep paired cards first. Only a single leftover card occupies the
      // final row, centered across the two-column desktop grid.
      if (remainders.length === 1) remainders[0].classList.add('sakura-centered-review-card');
    });
  };

  const start = () => {
    upgradeAll();
    updateRatingFills();
    copyProductReviewCountToSummary();
    enforceReviewSummaryLayout();
    setupPhotoCarousels();
    setupReviewImageLoading();
    setupReviewPhotoClicks();
    balanceDesktopReviewGrid();
    let reviewRefreshFrame = null;
    const observer = new MutationObserver((records) => {
      const relevantRecords = records.filter((record) => {
        const target = record.target;
        if (
          target instanceof Element &&
          target.closest('.jdgm-review-widget')
        ) {
          return true;
        }
        return Array.from(record.addedNodes).some((node) => (
          node instanceof Element &&
          (
            node.matches('.jdgm-review-widget') ||
            node.querySelector('.jdgm-review-widget')
          )
        ));
      });
      if (!relevantRecords.length || reviewRefreshFrame !== null) return;
      reviewRefreshFrame = window.requestAnimationFrame(() => {
        reviewRefreshFrame = null;
        relevantRecords.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('img[src*="review-images.judgeme.com"], img[srcset*="review-images.judgeme.com"], img[src*="review-images.judge.me"], img[srcset*="review-images.judge.me"]')) upgradeImage(node);
          upgradeAll(node);
        });
        });
        updateRatingFills();
        copyProductReviewCountToSummary();
        enforceReviewSummaryLayout();
        setupPhotoCarousels();
        setupReviewImageLoading();
        setupReviewPhotoClicks();
        balanceDesktopReviewGrid();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', balanceDesktopReviewGrid, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Sakura Judge.me purchased line inline */
(() => {
  const place = () => {
    document.querySelectorAll('.jdgm-review-widget .jm-review-item').forEach((item) => {
      const row = item.querySelector('.jm-review-item__content > .jm-cluster:first-child');
      if (!row || row.querySelector('.sk-purchased')) return;
      const line = [...item.querySelectorAll('.jdgm-review-content__body-content p')]
        .find((p) => /^\s*▸?\s*Purchased:/i.test(p.textContent));
      if (!line) return;
      const span = document.createElement('span');
      span.className = 'sk-purchased';
      const raw = line.textContent.replace(/^\s*▸?\s*Purchased:\s*/i, '').trim();
      const m = raw.match(/Color:\s*([^|]+?)\s*\|\s*Size:\s*(.+)$/i);
      const widget = item.closest('.jdgm-review-widget');
      let title = (widget && widget.dataset.productTitle) || '';
      if (m) {
        const color = m[1].trim();
        title = title.replace(new RegExp('\\s+' + color.replace(/[.*+?^$()|[\]\\{}]/g, '\\$&') + '$', 'i'), '').trim();
        span.textContent = (title ? title + ' \u00B7 ' : '') + color + ' / ' + m[2].trim();
      } else {
        span.textContent = raw;
      }
      row.appendChild(span);
      line.classList.add('sk-purchased-src');
    });
  };
  let timer = null;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(place, 120); };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
/* End Sakura Judge.me purchased line inline */
